/**
 * @desc 获取基地下所有角色
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** baseCode */
  baseCode: string;
  /** 基地id */
  baseId?: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryRolesResponse>> {
  return defHttp.get({
    url: '/web/role/listRoles',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryRolesResponse>> {
  return defHttp.get({
    url: '/mock/web/role/listRoles',

    params,
  });
}
